import { useMemo } from "react";
import { getCompanyFlag } from "../global/environmentVariables";

const SUPPORTED_EMBEDDED_ENVIRONMENTS = {
  // Add new embedded environments as we want here
  gw: {
    brandName: "Warhammer",
    storagePrefix: "warhammer",
  },
  wm: {
    brandName: "Warmachine",
    storagePrefix: "warmachine",
  },
};

export function useEmbeddedEnvironment() {
  const companyFlag = getCompanyFlag();

  return useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isEmbedded = urlParams.get("embed") === "true";

    const environmentConfig = SUPPORTED_EMBEDDED_ENVIRONMENTS[companyFlag];
    const isSupported = Boolean(environmentConfig);

    return {
      isEmbeddedEnvironment: isSupported && isEmbedded,
      environmentConfig: environmentConfig || null,
      brandName: environmentConfig?.brandName || null,
      storagePrefix: environmentConfig?.storagePrefix || null,
    };
  }, [companyFlag]);
}
